
import { Component, Vue } from 'vue-property-decorator';

import Form3ProcessHeader from "@/components/process/Form3/components/Form3ProcessHeader.vue";
import Form3CaseInformation from "@/components/process/Form3/components/Form3CaseInformation.vue";
import { form3StatusInfoType } from '@/types/Information/Form3';

@Component({
    components:{
        Form3ProcessHeader,
        Form3CaseInformation
    }
})
export default class StartForm3 extends Vue {

    stepsCompleted = {} as form3StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
